import type { ForwardedRef, ReactNode } from 'react';

import { forwardRef, memo } from 'react';
import { Outlet } from 'react-router';
import LoaderWrapper from '@ricoh/ria.client.core/components/indicator/loader/wrapper';
import { Z_INDEX } from '@ricoh/ria.client.core/constants/ui/layout';

import type { AppRouterContainerProps, AppRouterContainerRef } from './_.type';

import useAppRouterContainerHooks from './_.hook';

/** AppRouterContainer. */
export default memo(
  forwardRef(function AppRouterContainer(props: AppRouterContainerProps, ref: ForwardedRef<AppRouterContainerRef>): ReactNode {
    const { states } = useAppRouterContainerHooks(props, ref);

    return (
      <LoaderWrapper
        position="fixed"
        containerClassName="app-container min-w-md max-vw-100 vh-100"
        type="infinite-spinner"
        size="large"
        show={states.isLoading}
        zIndex={Z_INDEX.MAX}
      >
        <Outlet />
      </LoaderWrapper>
    );
  }),
);
